import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';
import WebFont from 'webfontloader';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import 'semantic-ui-css/semantic.min.css';

import store, {history} from './store';
import Routes from './routes';

// import 'moment-timezone';
import './index.css';
import registerServiceWorker from './registerServiceWorker';


const muiTheme = getMuiTheme({
	palette: {
		primary1Color: '#007EC0',	// App Bar color F2F2F2
		primary2Color: '#FF0000',	// ??
		primary3Color: '#9A9A9A',	// Toggle (disabled) color
		accent1Color: '#FFB613',	// ??
		accent2Color: '#E4E4E4',	// Hover table row color
		accent3Color: '#000000',	// Table Header text color
		textColor: '#4E4E4E',		// 4e4e4e
		alternateTextColor: '#FFFFFF',	// App Bar Text Color
		canvasColor: '#FFFFFF',
		borderColor: '#F2F2F2',
		disabledColor: '#DCDCDC'
		// disabledColor: fade(darkBlack, 0.3),
		// pickerHeaderColor: cyan500,
		// clockCircleColor: fade(darkBlack, 0.07),
		// shadowColor: fullBlack,
	}
});

WebFont.load({
	google: {
		families: [
			'Libre Franklin:300,400,500',
			'Roboto',
			'sans-serif'
		]
	}
});

ReactDOM.render(
	<Provider store={store()} >
		<ConnectedRouter history={history}>
			<MuiThemeProvider muiTheme={muiTheme}>
				<Routes />
			</MuiThemeProvider>
		</ConnectedRouter>
	</Provider>,
	document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js